<template>
  <div>
    <v-data-table
      :aria-label="$t('L_policy_coverage_details')"
      :headers="displayHeader ? headers : []"
      :items="data"
      hide-default-footer
      class="elevation-0 bg-white"
    >
      <template #item="props: any">
        <tr :class="props.item['background']">
          <td
            v-for="(header, headerIndex) in headers"
            :key="headerIndex + 'insured'"
            class="pl-2 pt-2 valign-top h5"
            :class="
              props.item[header.value as string] ? props.item[header.value as string].itemClass : ''
            "
          >
            <ResponsiveTableItem
              :item="props.item[header.value as string]"
              @click-item="$emit('clicked-item', props.item)"
              @link-item="$emit('linked-item', props.item)"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import ResponsiveTableItem from './ResponsiveTableItem.vue';
import { defineComponent, type PropType } from 'vue';
import { mapState } from 'pinia';
import { $t } from '@/i18n/i18n';

export default defineComponent({
  name: 'ResponsiveTable',
  components: {
    ResponsiveTableItem,
  },
  props: {
    displayHeader: {
      type: Boolean,
      required: false,
      default: true,
    },
    headers: {
      type: Array as PropType<Array<Record<string, unknown>>>,
      required: true,
    },
    data: {
      type: Array,
      required: true,
    },
    transformHeaders: {
      type: Function,
      required: false,
      default: (input: HTMLElement) => input,
    },
  },
  computed: {
    ...mapState(usePolicyStore, {
      isPending: 'isPending',
    }),
  },
  methods: {
    $t,
    getHeaders() {
      const th = [].slice.call(this.$el.querySelectorAll('th.column-header'));
      this.adaTable(th);
    },
    adaTable(th: HTMLElement[]) {
      th.forEach((item: HTMLElement) => {
        item.removeAttribute('aria-label');
      });
    },
  },
  mounted() {
    this.getHeaders();
  },
});
</script>

<style lang="scss">
:deep(th.column-header) {
  vertical-align: top;
  padding-top: 9px !important;
}

:deep(.valign-top) {
  vertical-align: top;
}

.group {
  font-size: 14px;
  font-weight: 600;
}
</style>
